'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var INCLUDE = exports.INCLUDE = 'INCLUDE';
var EXCLUDE = exports.EXCLUDE = 'EXCLUDE';
var ALL_PAGES = exports.ALL_PAGES = 'ALL_PAGES';